import { useSelector } from "react-redux";
import { RootState } from "toolkit/store";

const useOrientation = () => {
  const { orientation } = useSelector((state: RootState) => state.device);
  return orientation;
};

export default useOrientation;
